// src/App.js
import { lazy, memo, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Container from './components/Container';
import Header from './components/Header';
import BottomNavbar from './components/BottomNavbar';
import MovieDetails from './pages/MovieDetails';
import { SearchProvider } from './context/SearchContext';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';

// Lazy-load pages
const Home = lazy(() => import('./pages/Home'));
const Trending = lazy(() => import('./pages/Trending'));
const BoxOffice = lazy(() => import('./pages/BoxOffice'));
const Upcoming = lazy(() => import('./pages/Upcoming'));
const News = lazy(() => import('./pages/News'));

const MemoHeader = memo(Header);
const MemoBottomNavbar = memo(BottomNavbar);

function App() {
  return (
    <GlobalErrorBoundary>
      <Router>
        <SearchProvider>
          <Container>
            <MemoHeader />
          </Container>
          <Container className="main-content">
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/trending" element={<Trending />} />
                <Route path="/boxoffice" element={<BoxOffice />} />
                <Route path="/upcoming" element={<Upcoming />} />
                <Route path="/news" element={<News />} />
                <Route path="/movie/:id" element={<MovieDetails />} />
              </Routes>
            </Suspense>
          </Container>
          <MemoBottomNavbar />
        </SearchProvider>
      </Router>
    </GlobalErrorBoundary>
  );
}

export default App;
